module.exports = __webpack_public_path__ + "img/partners.ac8fbb2.webp";